import { APP_ID } from '@angular/core';

export const environment = {
  APP_ID,
  production: false,
  APP_BASE_URL: 'https://api.demo.medvisit.co.za',
};
